import { useUploadPolling } from '../../hooks/use-upload-polling';

/**
 * Runs upload polling for the logged in app. Renders nothing.
 */
export const UploadPoller = () => {
  useUploadPolling();
  return null;
};
